<div class="installation-card">
  <h2>{{ title }}</h2>

  <ng-content></ng-content>
</div>
